"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var EditCompany_1 = require("../../../components/Pages/Company/EditCompany");
var getState_1 = require("../../../utils/getState");
var MyCompany = function () {
    return React.createElement(EditCompany_1.default, { id: (0, getState_1.default)().user.company_id });
};
exports.default = MyCompany;
